import CircularLoader from "@/components/loading/LoadingComponent";
import { AuthContext } from "@/contexts/AuthContext";
import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const SHIELD_TWO_MIN_GOTA_DAYS = 365;

interface GuardProps {
    children: React.ReactNode;
}

const ShieldTwoEligibilityGuard = ({ children }: GuardProps) => {
    console.debug("Executing ShieldTwoEligibilityGuard");

    const { user, loading } = useContext(AuthContext);
    const navigate = useNavigate();

    useEffect(() => {
        // Check if the user has at least 365 days in GOTA subscription
        // If not, redirect to dashboard
        if (!loading && user) {
            if (!user.player) {
                navigate("/subscribe");
            } else if (
                user.player.gotaSubTimeInDays < SHIELD_TWO_MIN_GOTA_DAYS
            ) {
                navigate("/dashboard");
            }
        }
    }, [user, loading, navigate]);

    if (loading) {
        return <CircularLoader />;
    }

    return <>{children}</>;
};

export default ShieldTwoEligibilityGuard;
